module.exports = {"TAG_DEFAULT_INPUT_PLACEHOLDER":"คุณเลือกข้อมูลครบครบตามข้อจำกัดแล้ว","TAG_ADD_BUTTON":"เพิ่ม","TAG_INVALID_VALUE":"ข้อมูลไม่ถูกต้อง"}